import { Box, Flex } from 'components/elements'
import { TableItemRow, TableTd } from 'theme/globalStyleCss'
import { ShimmerCss, IconButtonCss, Tags2Css, ImageCss } from './styles'
import { TextShimmer } from './text'
import { AvatarShimmer } from './avatar'

export const JobOrderShimmer = () => {
  return (
    <TableItemRow>
      <TableTd align={'center'}>
        <AvatarShimmer showToggle={true} />
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Flex>
          <Box
            css={{
              ...ShimmerCss,
              ...ImageCss,
              borderRadius: '50%',
            }}
          ></Box>
          <Box
            css={{
              ...ShimmerCss,
              ...ImageCss,
              ml: '-$space$5',
              borderRadius: '50%',
            }}
          ></Box>
        </Flex>
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Flex>
          <Box
            css={{
              ...ShimmerCss,
              ...ImageCss,
              borderRadius: '50%',
            }}
          ></Box>
          <Box
            css={{
              ...ShimmerCss,
              ...ImageCss,
              ml: '-$space$5',
              borderRadius: '50%',
            }}
          ></Box>
        </Flex>
      </TableTd>
      <TableTd align={'center'}>
        <Flex>
          <Box
            css={{
              ...ShimmerCss,
              ...ImageCss,
              borderRadius: '50%',
            }}
          ></Box>
        </Flex>
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <Flex justify={'end'}>
          <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
        </Flex>
      </TableTd>
    </TableItemRow>
  )
}
